import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, VideoStopResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';
import { getFormattedOriginalSourcePage, isPlayerScreenActive } from '../utils';

export const mapVideoStop = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): VideoStopResult | undefined => {
    const progressPct = Math.round(parseFloat(payload.payload.percentOfPlayback.toFixed(2)));
    /* Note:
     * The Player screen may not be active when triggering the Playback_stop event in two cases:
     * 1. On non-web platforms, the event fires after navigating back from the player (unlike web).
     * 2. During autoplay/binge-watch, the Player remains the active screen.
     * Therefore, use the previous or current navigation state to determine the correct source page.
     * */
    const usePreviousState = !isPlayerScreenActive();

    return {
        ...mapBase(payload),
        action: EVENTS.VIDEO_STOP,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        progress_pct: progressPct,
        source_page: getFormattedOriginalSourcePage(payload, usePreviousState),
        source_rail: payload.payload.asset.sectionLabel,
        duration: payload.payload.duration,
    };
};
